import getType from"./getType";export function isNumber(payload){return getType(payload)==="Number"&&!isNaN(payload)}export default isNumber;